module.exports = __webpack_public_path__ + "static/media/livecasino.c0a09a88.gif";